export function FlattenGraphQl(a: any) {
  if (!a) {
    return a;
  }
  const value = { ...a };
  Object.keys(a).forEach(key => {
    if (value[key]?.edges) {
      value[key] = value[key].edges.map((a: { node: any }) => ({ ...FlattenGraphQl(a.node) }));
    }
  });

  return value;
}
